import React from 'react';
import Slider from 'react-slick';          // ← only needed if you later add carousels
import 'slick-carousel/slick/slick.css';   // (kept here so you don’t forget)
import 'slick-carousel/slick/slick-theme.css';

/* helper → resolves to  /public/assets/images/<file>  */
const img = (file) => `${process.env.PUBLIC_URL}/assets/images/${file}`;

export default function Services() {
  /* you could data-drive the six cards, but they’re hard-coded
     so the markup below matches the template exactly             */

  return (
    <div className="page">
      {/* ─────────────────────  PAGE-TITLE STRIPE  ───────────────────── */}
      <div className="ttm-page-title-row">
        <div className="ttm-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="page-title-heading ttm-textcolor-white">
                  <h2 className="title">Our Services</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─────────────────────  SITE-MAIN  ───────────────────── */}
      <div className="site-main">
        {/* ==========  SERVICE GRID  ========== */}
        <section className="ttm-row service-row-section clearfix">
          <div className="container">
            {/* section title */}
            <div className="row">
              <div className="col-lg-6 col-md-8 m-auto">
                <div className="section-title title-style-center_text">
                  <div className="title-header">
                    <h5>YOU CAN LEARN IT</h5>
                    <h2 className="title">
                      The High Standard Trusted &amp; Professional Services
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            {/* six-card grid */}
            <div className="row">
              {/* 1 ─ Translation Services */}
              <div className="ttm-box-col-wrapper col-lg-4 col-md-6 mb-4">
                <div className="featured-icon-box icon-align-before-heading style2 h-100">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                      <i className="flaticon-connection" />
                    </div>
                  </div>
                  <div className="featured-title">
                    <span>Explore The Features</span>
                    <h5>Translation Services</h5>
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        Professional translation in 50+ Indian regional
                        languages with cultural accuracy and domain-specific
                        precision. Native linguists ensure every word is
                        meaningful and locally relevant. Industry-specific
                        glossaries and CAT tools enhance consistency and
                        turnaround efficiency, while our stringent QA process
                        ensures flawless delivery every time. We bridge
                        communication gaps with clarity and expertise.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2 ─ DTP Services */}
              <div className="ttm-box-col-wrapper col-lg-4 col-md-6 mb-4">
                <div className="featured-icon-box icon-align-before-heading style2 h-100">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                      <i className="flaticon-customer-service" />
                    </div>
                  </div>
                  <div className="featured-title">
                    <span>Explore The Features</span>
                    <h5>DTP Services</h5>
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        Multilingual desktop publishing services that preserve
                        design across languages. We support all major tools for
                        flawless visual integrity. Complex formatting, accurate
                        typography, and culturally aware layout adaptation
                        ensure your message is delivered professionally in any
                        language. Our DTP experts align content and visuals for
                        maximum readability and localization accuracy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 3 ─ Content Writing */}
              <div className="ttm-box-col-wrapper col-lg-4 col-md-6 mb-4">
                <div className="featured-icon-box icon-align-before-heading style2 h-100">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                      <i className="flaticon-conversation-2" />
                    </div>
                  </div>
                  <div className="featured-title">
                    <span>Explore The Features</span>
                    <h5>Content Writing</h5>
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        Strategic content creation for websites, blogs, SEO, and
                        more. Our writers deliver audience-centric content that
                        engages and converts. Each piece is optimized for search
                        engines and tailored to reflect your brand voice,
                        ensuring relevance, clarity, and measurable impact. We
                        create compelling narratives that drive visibility and
                        digital engagement.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 4 ─ Website Localization */}
              <div className="ttm-box-col-wrapper col-lg-4 col-md-6 mb-4">
                <div className="featured-icon-box icon-align-before-heading style2 h-100">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                      <i className="flaticon-conversation-2" />
                    </div>
                  </div>
                  <div className="featured-title">
                    <span>Explore The Features</span>
                    <h5>Website Localization</h5>
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        Transforming your website for global audiences with
                        linguistically and culturally adapted content. Our
                        process ensures functional and visual alignment. UI
                        elements, multimedia, and forms are all localized to
                        ensure a seamless user experience across every region.
                        We help global brands resonate locally with precision
                        and relevance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 5 ─ Voiceover & Subtitling */}
              <div className="ttm-box-col-wrapper col-lg-4 col-md-6 mb-4">
                <div className="featured-icon-box icon-align-before-heading style2 h-100">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                      <i className="flaticon-global" />
                    </div>
                  </div>
                  <div className="featured-title">
                    <span>Explore The Features</span>
                    <h5>Voiceover &amp; Subtitling</h5>
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        Multi-language voiceovers and accurate subtitles to meet
                        diverse media localization needs. Delivered with perfect
                        timing and tone by native experts. We support broadcast,
                        e-learning, and marketing materials with studio-quality
                        output and synchronized precision. Our voice solutions
                        ensure emotional and linguistic alignment for every
                        target market.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 6 ─ Software Localization */}
              <div className="ttm-box-col-wrapper col-lg-4 col-md-6 mb-4">
                <div className="featured-icon-box icon-align-before-heading style2 h-100">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-lg ttm-icon_element-color-grey ttm-icon_element-style-rounded">
                      <i className="flaticon-conversation" />
                    </div>
                  </div>
                  <div className="featured-title">
                    <span>Explore The Features</span>
                    <h5>Software Localization</h5>
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        Localizing software interfaces and help files for a
                        seamless user experience worldwide. Functional testing
                        ensures usability across all languages. Strings, UI
                        elements, and embedded content are adapted with
                        cultural precision for optimal global engagement. We
                        deliver scalable solutions for cross-market deployment
                        and user adoption.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>{/* row */}
          </div>
        </section>
      </div>
    </div>
  );
}